import React, { Component } from 'react'
import { selectMode } from '../../../actions/commonActions'
import { connect } from 'react-redux'

export class VaultCusId extends Component {
    componentDidMount() {
        this.props.selectMode('integration_guide')
    }

    render() {        
        return (
        <div className="stepPageContainer">  

            <h3 className="stepPageTitle">Customer ID Changes</h3>
            
            <p>Some financial transactions take the customer ID as an optional value. The customer ID may or may not
            already be in the Vault profile when the transaction is sent. Therefore, it is possible to change the value of
            the customer ID by performing a financial transaction<br/>
            The table below shows what the customer ID will be in the response field after a financial transaction is
            performed.
            </p>
            
            <h3 className="stepPageTitle">Vault Financial Transactions</h3>
            
            <p>After a financial transaction is complete, the response fields indicate all the values that are currently
            saved under the profile that was used.
            </p>
            
            <h3 className="stepPageTitle" style={{ marginLeft:"25vw",fontSize:"1vw"}}>Table 2: Customer ID use in response fields</h3>
            
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Already in profile?</th>
                    <th>Passed in?</th>
                    <th>Version used in response</th>
                </tr>
                <tr>
                    <td>No</td>
                    <td>No</td>
                    <td>Customer ID not used in transaction</td>
                </tr>
                <tr>
                    <td>No</td>
                    <td>Yes</td>
                    <td>Passed in</td>
                </tr>
                <tr>
                    <td>Yes</td>
                    <td>No</td>
                    <td>Profile</td>
                </tr>
                <tr>
                    <td>Yes</td>
                    <td>Yes</td>
                    <td>Passed in</td>
                </tr>
                </tbody>
            </table>
        </div>
        )
    }
}



const mapStateToProps = state => {
    const {mode} = state.common.sideNav;
    return { mode};
  }
  
export default connect(mapStateToProps, { selectMode})(VaultCusId)
  
  
